<div #questionElem [class.report-control]="reportControl">
    @if (groups$ | async; as groups; ) {
        @if (isMobileView) {
            @if (selectedGroup) {
                <div class="mb-[84px] flex flex-col gap-y-11"
                >
                    @for (item of groups; track $index) {
                        <span [id]="formId + '_'+ item.group.GroupVersionsID" class="text-xl font-bold text-default"
                              [class.hidden]="item.group.Name && item.group.Name.length==0">{{ item.group.Name }}</span>
                        @for (questionIndex of item.questions; track $index) {
                            <bizz-checklist-question [id]="formId + '_question_'+ questionIndex"
                                                     [questionNumber]="questionIndex+1"
                                                     [isMobileView]="isMobileView"
                                                     [isLocked]="isLocked() || isReadonly()" [isRequired]="isRequired()"
                                                     [(question)]="questions[questionIndex]"
                                                     (questionChange)="dispatchChange($event)"
                                                     (collapseQuestion)="questionClicked(questionIndex, $event)"
                                                     [isLoading]="isSaveQuestionLoading"
                                                     [isCurrentQuestion]="currentQuestionIndex == questionIndex"
                                                     [isDarkTheme]="isDarkTheme"
                                                     [class.disabled]="isSaveQuestionLoading"></bizz-checklist-question>
                        }
                    }
                </div>
            }
            @if (showSearch || showCategories && groups.length > 1) {
                <div class="transition-500 fixed left-0 top-0 z-[1] h-svh w-svw bg-[rgba(0,0,0,0.5)] transition-all"
                     (click)="hidePopups()"></div>
            }
            @if (showFooter) {
                <div class="fixed bottom-0 left-0 z-10 w-full border-t-2 border-list-row bg-body-popup">
                    <div class="flex items-center justify-between px-8 py-5">
                        @if (questions.length) {
                            <bizz-checklist-progressbar [isMobileView]="isMobileView"
                                                        [checkedQuestions]="checkedQuestions"
                                                        [totalQuestions]="questions.length"></bizz-checklist-progressbar>
                        }

                        <div class="w-full"></div>
                        <button [class.active]="showSearch"
                                class="relative size-[50px] shrink-0 rounded-full bg-section"
                                (click)="toggleShowSearch()">
                            <bizz-icon
                                    class="absolute left-1/2 top-1/2 size-5 translate-x-[-50%] translate-y-[-52%] text-button"
                                    iconName="magnifying-glass"></bizz-icon>
                        </button>

                        <div class="absolute bottom-[85px] left-0 w-full rounded-t-lg bg-body-popup pb-0"
                             [class.p-5]="showSearch">
                            <div class="transition-500 overflow-y-hidden transition-all"
                                 [class]="showSearch? 'pt-0.5 h-[25svh]':'h-[0] '">
                                <bizz-checklist-searchbar #searchInput [isMobileView]="isMobileView" [data]="questions"
                                                          (valueChanged)="filterChange($event); toggleShowSearch()"></bizz-checklist-searchbar>

                            </div>
                        </div>
                        <div class="w-full"></div>
                        <button [class.active]="showCategories" [disabled]="groups.length <= 1"
                                class="relative size-[50px] shrink-0 rounded-full bg-section"
                                (click)="toggleShowCategories()">
                            <bizz-icon class="absolute left-1/2 top-1/2 size-5 translate-x-[-54%] translate-y-[-50%]"
                                       iconName="layer-group"></bizz-icon>
                        </button>

                        <bizz-checklist-groups [show]="showCategories" [isMobileView]="isMobileView" [groups]="groups"
                                               [selectedGroup]="selectedGroup"
                                               (groupChanged)="groupChanged($event); toggleShowCategories();"></bizz-checklist-groups>
                        <div class="w-full"></div>
                        <bizz-loader-button class="h-10" buttonClass="save"
                                            (click)="saveQuestion(questions[currentQuestionIndex])"
                                            [isLoading]="isSaveQuestionLoading"
                                            [disabled]="!!isLocked() || !!questions[currentQuestionIndex]?.isCollapsed || currentQuestionIndex == -1 ">
                            {{ (questions.length == currentQuestionIndex + 1 ? "Complete" : "Next") | translate }}
                            <bizz-icon class="size-4" iconName="caret-right"></bizz-icon>
                        </bizz-loader-button>
                    </div>
                </div>
            }
        } @else {
            <div class="flex h-full w-full gap-4 p-4">
                @if (groups.length > 1 && getScreenWidth > BreakpointEnum.LG) {
                    <div class="w-56 flex-shrink-0 border-r-2 border-divider pr-3">
                        <bizz-checklist-sidebar [formId]="formId" [groups]="groups" [activeGroup]="selectedGroup!"
                                                (groupChanged)="groupChanged($event)"></bizz-checklist-sidebar>
                    </div>

                }
                <div class="flex w-full flex-col gap-y-3">

                    @if (questions.length) {

                        <div class="flex items-center justify-between gap-2">
                            <div>

                                @if (groups.length > 1 && getScreenWidth < BreakpointEnum.LG) {
                                    <bizz-checklist-groups [show]="showCategories" [groups]="groups"
                                                           [selectedGroup]="selectedGroup"
                                                           (groupChanged)="groupChanged($event); toggleShowCategories();"></bizz-checklist-groups>
                                }
                            </div>

                            <div class="flex items-center justify-end gap-2">
                                @if (!reportControl) {
                                    <bizz-checklist-searchbar [show]="true" [data]="questions"
                                                              (valueChanged)="filterChange($event)"></bizz-checklist-searchbar>
                                    <bizz-checklist-progressbar [checkedQuestions]="checkedQuestions"
                                                                [totalQuestions]="questions.length"></bizz-checklist-progressbar>
                                }
                            </div>
                        </div>


                    }
                    <div class="w-full overflow-y-auto !scroll-smooth transition-all"
                         [class]="reportControl ? 'h-full no-scrollbar' : 'max-h-[calc(100svh_-_20rem)]'">
                        <div [id]="formId + '_questions'" class="!scroll-smooth transition-all" style="height: 100%">

                            <div class="grid gap-y-8 !scroll-smooth transition-all">
                                @for (item of groups; track $index) {
                                    <span [id]="formId + '_'+ item.group.GroupVersionsID"
                                          class="text-xl font-bold text-default"
                                          [class.hidden]="item.group.Name && item.group.Name.length==0">{{ item.group.Name }}</span>
                                    @for (questionIndex of item.questions; track $index) {
                                        <bizz-checklist-question [id]="formId + '_question_'+ questionIndex"
                                                                 [questionNumber]="questionIndex+1"
                                                                 [isMobileView]="isMobileView"
                                                                 [isLocked]="(isLocked() || isReadonly()) && !reportControl"
                                                                 [reportControl]="reportControl"
                                                                 [isRequired]="isRequired()"
                                                                 [(question)]="questions[questionIndex]"
                                                                 (questionChange)="dispatchChange($event)"
                                                                 (collapseQuestion)="questionClicked(questionIndex, $event)"
                                                                 [isLoading]="isSaveQuestionLoading"
                                                                 [isCurrentQuestion]="currentQuestionIndex == questionIndex"
                                                                 [isDarkTheme]="isDarkTheme"
                                                                 [class.disabled]="isSaveQuestionLoading"></bizz-checklist-question>
                                        @if (currentQuestionIndex == questionIndex &&
                                        !(isLocked() || isReadonly() || reportControl) &&
                                        !questions[questionIndex]?.isCollapsed) {
                                            <bizz-loader-button class="ml-9 w-fit" buttonClass="save"
                                                                (click)="saveQuestion(questions[questionIndex])"
                                                                [isLoading]="isSaveQuestionLoading">
                                                {{
                                                    (questions.length == questionIndex + 1 ?
                                                            "Complete" :
                                                            "Next") | translate
                                                }}
                                                <bizz-icon class="size-4" iconName="caret-right"></bizz-icon>
                                            </bizz-loader-button>
                                        }
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        }
    }
</div>